var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.9 4v1.59485531h6.2v-1.59485531h1.55v1.59485531h.8c.85 0 1.55.72025723 1.55 1.5948553v11.21543409c0 .8745981-.7 1.5948553-1.55 1.5948553h-10.9c-.85 0-1.55-.7202572-1.55-1.5948553v-11.21543409c0-.87459807.7-1.5948553 1.55-1.5948553h.8v-1.59485531zm8.55 6.3794212h-10.9v8.0257235h10.9zm0-3.18971059h-10.9v1.59485531h10.9z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d7c07fe2d88d28388676e662b73961d.svg";
export { ForwardRef as ReactComponent };